/* eslint-disable import/no-cycle */

'use-strict';

import angular from 'angular';
import { UsersService } from '../../shared/users/users.service';
import { UserRole } from '../../src/app/@types/user';

export interface ApiIdentifier {
  method: 'GET' | 'POST' | 'DELETE' | 'PUT',
  resource: string,
}

export class PermissionsService {
  private usersService: UsersService;

  constructor(
    usersService: UsersService,
  ) {
    'ngInject';

    this.usersService = usersService;
  }

  /**
   * Check if current user is either admin or has one of the supplied roles.
   */
  public isPermitted = (roles: UserRole[]): boolean => {
    if (this.usersService.currentUserAdmin()) return true;

    const currentUserRoles = this.usersService.currentUser()?.roles;
    if (!currentUserRoles) return false;

    if (roles.some((role) => currentUserRoles.includes(role))) return true;
    return false;
  };
}

export default angular.module('services.permissionsService', [])
  .service('permissionsService', PermissionsService)
  .name;
